import { render, staticRenderFns } from "./ShareView.vue?vue&type=template&id=e663fc64&scoped=true"
import script from "./ShareView.vue?vue&type=script&lang=js"
export * from "./ShareView.vue?vue&type=script&lang=js"
import style0 from "./ShareView.vue?vue&type=style&index=0&id=e663fc64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e663fc64",
  null
  
)

export default component.exports